import * as React from "react";
import { Modal, Button } from "semantic-ui-react";
import { connect } from "react-redux";

import * as moment from "moment";

import { isRequestActive } from "redux-request-loading";

import { navigateToParentRoute } from "@teamprevent/common/routing/actions";

import { AdHocCalendarAppointmentForm } from "../../../bookAppointments/components/AdHocCalendarAppointmentForm";

import { ApplicationState, BookAppointmentErrors, AdHocCalendarAppointmentModel } from "../../../bookAppointments/models";
import { AdminUserDetailModel } from "../../../crud/adminUser";
import { CREATE_TIME_NOTE_APPOINTMENT } from "../actionTypes";
import { createTimeNoteAppointment } from "../actions";

interface StateProps {
    adminUsers: AdminUserDetailModel[];
    creatingAppointment: boolean;
    bookAppointmentErrors: BookAppointmentErrors;
    time: moment.Moment;
    clinicianId?: string;
}

interface DispatchProps {
    close: () => void;
    save: (model: AdHocCalendarAppointmentModel) => Promise<void>;
}

interface MergedProps {
    adminUsers: AdminUserDetailModel[];
    creatingAppointment: boolean;
    time: moment.Moment;
    bookAppointmentErrors: BookAppointmentErrors;
    clinicianId?: string;
    close: () => void;
    save: (model: AdHocCalendarAppointmentModel) => Promise<void>;
}

export class CreateTimeNoteModalUnconnected extends React.Component<MergedProps> {
    // eslint-disable-next-line deprecation/deprecation
    private bookForm: AdHocCalendarAppointmentForm;
    // eslint-disable-next-line deprecation/deprecation
    private getRef = (instance: AdHocCalendarAppointmentForm) => this.bookForm = instance;

    public render() {
        return (
            <Modal open closeOnDimmerClick={false}>
                <Modal.Content>
                    {this.renderCalendarForm()}
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.props.close} content="Cancel" />
                    <Button
                        loading={this.props.creatingAppointment}
                        disabled={this.props.creatingAppointment}
                        onClick={this.onSubmit}
                        content="Save"
                    />
                </Modal.Actions>
            </Modal>
        );
    }

    private onSubmit = () => this.bookForm.submit();

    private renderCalendarForm = () => {
        return (
            <AdHocCalendarAppointmentForm
                adminUsers={this.props.adminUsers}
                ref={this.getRef}
                startTime={this.props.time}
                clinicianId={this.props.clinicianId}
                bookAppointmentErrors={this.props.bookAppointmentErrors}
                save={this.props.save}
                useExtendTillDay
            />);
    };
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    adminUsers: state.adminUsers,
    creatingAppointment: isRequestActive(state, CREATE_TIME_NOTE_APPOINTMENT),
    bookAppointmentErrors: state.bookAppointments.bookAppointmentErrors,
    clinicianId: state.router.query.clinicianId,
    time: state.router.query.time && moment.utc(state.router.query.time)
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
    close: () => dispatch(navigateToParentRoute()),
    save: (model) => dispatch(createTimeNoteAppointment(model))
});

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps): MergedProps => {
    const { ...propsFromState } = stateProps;
    return {
        ...propsFromState,
        close: dispatchProps.close,
        save: dispatchProps.save
    };
};

export const CreateTimeNoteModal = connect(mapStateToProps, mapDispatchToProps, mergeProps)(CreateTimeNoteModalUnconnected);
